module.exports = __webpack_public_path__ + "static/img/coupons_goods_air2.7f0fb04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/coupons_goods_air2.png
// module id = HX3D
// module chunks = 1